/**
 * Defines which direction the items of ui5-toolbar will be aligned.
 * @public
 */
enum ToolbarAlign {
	/**
	 * Toolbar items are situated at the `start` of the Toolbar
	 * @public
	 */
	Start = "Start",

	/**
	 * Toolbar items are situated at the `end` of the Toolbar
	 * @public
	 */
	End = "End",
}

export default ToolbarAlign;
